"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVITY_TO_REDO_VAR = exports.CHARACTER_ACTIVITIES_PENDING_INITIALISE_VAR = exports.CHARACTER_ACTIVITY_RESUME_SCENES_VAR = exports.CHARACTER_ACTIVITIES_COMPLETED_VAR = exports.CHARACTER_ACTIVITIES_IN_PROGRESS_VAR = void 0;
/** Character variable: JSON string array of activity ids currently in progress. */
exports.CHARACTER_ACTIVITIES_IN_PROGRESS_VAR = 'character_activities_in_progress';
/** Character variable: JSON string array of activity ids completed. */
exports.CHARACTER_ACTIVITIES_COMPLETED_VAR = 'character_activities_completed';
/** Character variable: JSON object mapping activity id → scene id for activity-list resume navigation. */
exports.CHARACTER_ACTIVITY_RESUME_SCENES_VAR = 'character_activity_resume_scenes';
/**
 * Character variable: JSON array of activity ids pending Initialise on the next
 * {@code startActivity} for that id (set by {@code removeActivitiesFromCharacterProgress} during redo).
 */
exports.CHARACTER_ACTIVITIES_PENDING_INITIALISE_VAR = 'character_activities_pending_initialise';
/**
 * Character or adventure string variable: set when the player uses Activity-List REDO so the target scene
 * can reset progress. Cleared by authoring after handling.
 */
exports.ACTIVITY_TO_REDO_VAR = 'activity_to_redo';
//# sourceMappingURL=constants.js.map